import { uuidv7 } from "uuidv7";
import { User } from "@src/interfaces/user.interface";
import { REFRESH_TOKEN_KEY,TOKEN_KEY, UUID_TOKEN_KEY } from "@features/auth/constants";

export const getUUID = () => {
    if (typeof window !== "undefined") {
        const uuid = localStorage.getItem(UUID_TOKEN_KEY);
        if (!uuid) {
            const newUuid = uuidv7();
            localStorage.setItem(UUID_TOKEN_KEY, newUuid);
            return newUuid;
        }
        return uuid;
    } else {
        return "";
    }
};

export const getAccessToken = () => {
    if (typeof window !== "undefined") {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            return "";
        }
        return token;
    } else {
        return "";
    }
};
export const getRefreshToken = () => {
    if (typeof window !== "undefined") {
        const token = localStorage.getItem(REFRESH_TOKEN_KEY);
        if (!token) {
            return "";
        }
        return token;
    } else {
        return "";
    }
};

export const setAccessToken = (token: string) => {
    if (typeof window !== "undefined") {
        localStorage.setItem(TOKEN_KEY, token);
        return true;
    }
    return false;
};

export const setRefreshToken = (token: string) => {
    if (typeof window !== "undefined") {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
        return true;
    }
    return false;
};

export const removeAccessToken = () => {
    if (typeof window !== "undefined") {
        localStorage.removeItem(TOKEN_KEY);
        return true;
    }
    return false;
};

export const removeRefreshToken = () => {
    if (typeof window !== "undefined") {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        return true;
    }
    return false;
};

export const getUserData = () => {
    if (typeof window === "undefined") return null;

    const user = localStorage.getItem("user");
    if (!user) return null;

    try {
        return JSON.parse(user);
    } catch {
        return null;
    }
};

export const setUserData = (user: User) => {
    if (typeof window !== "undefined") {
        localStorage.setItem("user", JSON.stringify(user));
        return true;
    }
    return false;
};

export const clearAuthData = () => {
    removeAccessToken();
    removeRefreshToken();

    if (typeof window !== "undefined") {
        localStorage.removeItem("user");
        return true;
    }
};